import PropTypes from 'prop-types';
import React from 'react';
import { Wrapper } from './SimpleCount.styles';

export const SimpleCount = (props) => {
  let value;
  if (typeof props === 'string') {
    value = props;
  } else if (
    typeof props === 'object' &&
    props !== null &&
    typeof props.cell.value !== 'string'
  ) {
    value = props.cell.value && Object.values(props.cell.value).join(' ');
  } else if (typeof props.cell.value === 'string') {
    value = props.cell.value;
  } else {
    value = 'N/A';
  }

  return <Wrapper>{value}</Wrapper>;
};

SimpleCount.propTypes = {
  cell: PropTypes.object,
};
